<template>
    
    <b-modal id="tos-modal" ref="tos-modal" title="Terms of Service" size="xl" hide-footer scrollable>
        <div class="container" style="padding-top:100px">
            <h3 class="text-center main-sub-title">legal information</h3>
            <h2 class="text-center main-title">Terms of Services and Use</h2>
        </div>
        
    </b-modal>

</template>

<script>
export default {

    name: 'Tos',

    data() {
        return {

        }
    }

}
</script>

<style lang="less">
@import '../less/colors.less';

#tos-modal {

    .modal-dialog {
            max-width: none!important;
            width: 100%!important;
            max-height: 100%;
            margin: 0 auto;
            min-height: 100%;
            height: 100%;
        }

        .modal-content {
            max-height: 100%;
            border: 0;
            border-radius: 0;
            height: 100%;
        }

        .modal-header {
            border-radius: 0;
            z-index: 10;
            -webkit-box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
            box-shadow: 0px 3px 10px rgba(0, 0, 0, 0.1);
        
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Tos.vue